import '../../utils/index2.mjs';
import Empty from './src/empty4.mjs';
export { emptyProps } from './src/empty3.mjs';
import { withInstall } from '../../utils/vue/install2.mjs';

const ElEmpty = withInstall(Empty);

export { ElEmpty, ElEmpty as default };
//# sourceMappingURL=index2.mjs.map
